export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-18.c4319798.png";